import { emit, events } from '@estee/elc-service-bus';
import { RampStore } from '../internal/stores/RampStore';
import { DRUPAL_ACCOUNT_FORGOT_PASSWORD } from '../routes';
import { diContainer, serviceNames } from '../service-setup/diContainer';

export class ForgotPasswordUseCase {
    private rampStore: RampStore;

    constructor() {
        this.rampStore = diContainer.get(serviceNames.rampStore);
    }

    public execute = () => {
        emit(events.FORGOT_PASSWORD_LINK_CLICK);
        this.rampStore.goToExternalUrl(DRUPAL_ACCOUNT_FORGOT_PASSWORD);
    };
}
